export const ONBOARDING_BROWSER_FLOWS_LAYER =
  'hackhouse--onboarding-browser-flows';

export const ONBOARDING_BROWSER_FLOWS_VARIANT_PARAM = 'variant';
